module.exports = __webpack_public_path__ + "static/img/plan-b.424063fb.png";